__webpack_require__.p = "https://scroogebot-app-dev-38e66.web.app/";